import React from "react";
import AllNflGamesHelper from "../../classes/allNflGamesHelper";
import { useParams } from "react-router-dom";
import useGetter from "../../hooks/queryResults/useGetter";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useNflGamesForWeek from "../../hooks/queryResults/useNflGamesForWeek";
import Util from "../../util/util";
import WeekLinksBar from "../nav/WeekLinksBar";
import Loading from "../ui/Loading";
import TabSection from "../ui/TabSection";
import NflGameBoxScore from "./NflGameBoxScore";
import NflGamePlayByPlay from "./NflGamePlayByPlay";
import NflGameScoringPlays from "./NflGameScoringPlays";
import NflGamesScoreboard from "./NflGamesScoreboard";

export default function NflGameStats() {
  const { league: leagueUrl, season, week: weekUrl, nflGameSlug } = useParams();
  const week = Util.weekFromUrl(weekUrl);
  const { nflGamesData, nflGamesQuery } = useNflGamesForWeek(season, week);

  let nflGame;

  if (nflGamesData) {
    const allNflGamesHelper = new AllNflGamesHelper(nflGamesData);
    const nflGames = allNflGamesHelper.getWeekGames(week);
    const [awayAbbr, homeAbbr] = nflGameSlug.split("-");
    for (const g of nflGames) {
      if (g.teams.away.abbr === awayAbbr && g.teams.home.abbr === homeAbbr) {
        nflGame = g;
        break;
      }
    }
  }

  const { data: nflGameStatsData, query: nflGameStatsQuery } = useGetter(
    `/nfl/stats/game/${nflGame?.id}`,
    { enabled: !!nflGame }
  );

  const isLoading = useIsLoading(
    nflGamesData,
    nflGamesQuery,
    nflGameStatsData,
    nflGameStatsQuery
  );
  if (isLoading) return <Loading />;

  return (
    <div>
      <div style={{ margin: "0 0.5rem 1rem" }}>
        <WeekLinksBar path={`/${leagueUrl}/${season}/:week/nfl`} />
      </div>
      <NflGamesScoreboard />
      <h1>
        NFL Home - Week {week} - {nflGameSlug}
      </h1>
      <div
        style={{ backgroundColor: "white", color: "#777", padding: "0.5rem" }}
      >
        <TabSection
          labels={["Box Score", "Scoring Plays", "Play-by-Play"]}
          panels={[
            <NflGameBoxScore nflGameStatsData={nflGameStatsData} />,
            <NflGameScoringPlays nflGameStatsData={nflGameStatsData} />,
            <NflGamePlayByPlay nflGameStatsData={nflGameStatsData} />,
          ]}
        />
      </div>
    </div>
  );
}
